module.exports = __webpack_public_path__ + "img/090_thumbnail.c5029224.jpg";